module.exports = __webpack_public_path__ + "media/images/png/rent/1-bd72bac1cdf5b8e895e778d55edd9aff.png";